import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { renameContentFolderRequested } from 'features/content-library/actions';

export function* renameLibraryFolderSaga(action: ReturnType<typeof renameContentFolderRequested>) {
  yield call(SignalingSocket.send, { event: 'renameLibraryFolder', data: action.payload });
}
